// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZbzpBPHOPNUNZ7Ppq1tX .cC3y5ew_wHgNItgzQOxv{margin-top:16px}.J7hkmwlYe6gBrWFKIIwA{flex-direction:column;gap:8px;margin:0 -17px;padding-top:40px;display:flex}.yayuBHEf1QQ5R6VV4jEO{flex-direction:column;gap:20px;padding:20px 20px 32px;display:flex;position:relative}.yayuBHEf1QQ5R6VV4jEO:after{content:"";background:var(--border-neutral-default);height:1px;position:absolute;bottom:0;left:17px;right:17px}.iJhkUpSeZcSYDt6en0SW{gap:12px;padding:20px}.EmlfPHSLjGcRze6PvTTx{border-color:var(--border-neutral-default)!important}.sOrqwoOgy48gIhw4YoTp{background:var(--background-primary-inverted-primary);position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forbiddenTopicsWrap": `ZbzpBPHOPNUNZ7Ppq1tX`,
	"forbiddenMessageAgreed": `cC3y5ew_wHgNItgzQOxv`,
	"topicsWrap": `J7hkmwlYe6gBrWFKIIwA`,
	"collapseContent": `yayuBHEf1QQ5R6VV4jEO`,
	"headerClassName": `iJhkUpSeZcSYDt6en0SW`,
	"divider": `EmlfPHSLjGcRze6PvTTx`,
	"stickyActions": `sOrqwoOgy48gIhw4YoTp`
};
export default ___CSS_LOADER_EXPORT___;
